// Convert JSON to Hypertranscript HTML
export function jsonArrayToHtml(arrayData) {
  // Create an empty <article> element
  const div = document.createElement('div');

  const article = document.createElement('article');

  // Create an empty <section> element
  const section = document.createElement('section');

  // Add the <section> element to the <article> element
  article.appendChild(section);

  // Get the <p> elements data from the JSON object
  const paragraphs = arrayData;

  // Iterate through each <p> element
  // for (const paragraph of paragraphs) {
  paragraphs.forEach((paragraph) => {
    // Create an empty <p> element
    const p = document.createElement('p');
    p.setAttribute('class', 'mb-5');

    // Add the <p> element to the <section> element

    // Get the <span> elements data from the JSON object

    const words = paragraph.text.split(' ').filter(Boolean);

    // Calculate duration of each word
    const word_length = (paragraph.end - paragraph.start) / words.length;

    const speakerElement = document.createElement('span');
    speakerElement.setAttribute('class', 'text-[rgb(102,102,102)] font-bold cursor-pointer speaker');
    speakerElement.setAttribute('data-m', paragraph.start * 1000);
    speakerElement.innerText = paragraph.speaker;
    p.appendChild(speakerElement);

    // counter neede so that same words don't get same attributes
    let counter = 0;
    for (const word of words) {
      const spanElement = document.createElement('span');

      // Set the "data-m" attribute value
      spanElement.setAttribute('data-m', (paragraph.start + word_length * counter) * 1000);

      spanElement.setAttribute('class', 'text-[rgb(102,102,102)]');

      // Set the text content of the <span> element
      spanElement.innerText = counter == 0 ? ` ${word} ` : counter < words.length - 1 ? `${word} ` : word;

      // Add the <span> element to the <p> element
      p.appendChild(spanElement);
      counter += 1;
    }
    section.appendChild(p);
  });

  div.appendChild(article);
  // Return the <article> element

  return div.innerHTML;
}

export default jsonArrayToHtml;
